import { OFFER_FIRST_TYPE } from "@constants";

export function getShopCartAfterOffer(
    // eslint-disable-next-line
    shopCart: any,
    offer: OfferType,
    // eslint-disable-next-line
    action: string,
    productRef?: string,
    keyProduct?: string
    // eslint-disable-next-line
): Record<string, any> {
    try {
        console.log(
            "shopCart in starting getShopCartAfterOffer function ",
            JSON.stringify({
                shopCart,
                action,
                productRef,
                keyProduct,
            })
        );
        let priceToOffer = 0;

        const newshopCart = Object.keys(shopCart).reduce(
            // eslint-disable-next-line
            (prev: any, cur: any) => {
                const current = shopCart[cur];

                if (current.compositions) {
                    const updatedCompositions = Object.fromEntries(
                        Object.entries(current.compositions)
                            // eslint-disable-next-line
                            .sort(([, a]: any, [, b]: any) =>
                                offer.isMax
                                    ? a.initialPrice - b.initialPrice
                                    : b.initialPrice - a.initialPrice
                            ) // eslint-disable-next-line
                            .map(([key, value]: any, index) => {
                                if (action === "add") {
                                    if (index < offer.y) {
                                        priceToOffer += value.price;
                                    }
                                } else if (
                                    action === "remove" &&
                                    value.reference === productRef &&
                                    keyProduct === key &&
                                    index < offer.y
                                ) {
                                    priceToOffer += value.initialPrice;
                                }

                                return [
                                    key,
                                    {
                                        ...value,
                                        price:
                                            index < offer.y && action === "add"
                                                ? 0
                                                : index < offer.y &&
                                                  action === "remove"
                                                ? value.initialPrice
                                                : value.price,
                                        isOfferLight:
                                            index < offer.y && action === "add"
                                                ? true
                                                : index < offer.y &&
                                                  action === "remove"
                                                ? false
                                                : false,
                                    },
                                ];
                            })
                    );

                    prev[cur] = {
                        ...current,
                        compositions: updatedCompositions,
                    };
                } else {
                    prev[cur] = current;
                }
                return prev;
            },
            {}
        );
        console.log(
            "new shopCart in finishing getShopCartAfterOffer function ",
            JSON.stringify({ newshopCart, action, productRef, keyProduct })
        );
        return {
            newshopCart,
            priceToOffer,
        };
    } catch (error) {
        console.error(
            "Error in getShopCartAfterOffer:",
            error,
            JSON.stringify({
                shopCart,
                offer,
                action,
                productRef,
                keyProduct,
            })
        );

        throw error;
    }
}

export function getFirstCompositionKeyCount(
    data: ShopCartStructureType,
    offer: OfferType
): boolean {
    if (!offer || !offer.isEnabled || offer.type !== OFFER_FIRST_TYPE)
        return false;

    const firstMainKey = Object.keys(data)[0];

    if (!firstMainKey) return false;

    const compositions = data[firstMainKey]?.compositions;

    if (!compositions || typeof compositions !== "object") return false; // No compositions

    return offer.x === Object.keys(compositions).length;
}
